<template>
  <div class="mystudio container-fluid">
    <div class="container-fluid">
      <div class="row" id="dashboardCardDiv">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header card-header-icon row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-doom-yoga">Welcome Kamellia!</h4>
              </div>
            </div>
          </div>
          <b-card class="p-3">
            <p class="my-studio-dy-p my-0">
              Here are a few things to help you manage your studio.
            </p>

            <b-card
              title="My Events"
              tag="article"
              class="card-transparent-background doom-yoga-border-div mb-2"
            >
              <b-card-text class="mb-2">
                Create your online classes
              </b-card-text>

              <router-link
                to="/doom_yoga/my_events"
                class="card-link doomYogaLink"
              >
                Create Event
                <span class=" mx-1 my-auto"> <font-awesome-icon icon="fa-solid fa-arrow-right"  class="align-middle"  /> </span>
              </router-link>
            </b-card>
            <b-card
              title="Upload A Video"
              tag="article"
              class="card-transparent-background doom-yoga-border-div mb-2"
            >
              <b-card-text class="mb-2">
                Upload pre-recorded and live videos
              </b-card-text>

              <router-link
                to="/doom_yoga/video_library"
                class="card-link doomYogaLink d-flex "
              >
                Go To Library
                <span class=" mx-1 my-auto"> <font-awesome-icon icon="fa-solid fa-arrow-right"  class="align-middle"  /> </span>
              </router-link>
            </b-card>
            <b-card
              title="Upload Audio"
              tag="article"
              class="card-transparent-background doom-yoga-border-div mb-2"
            >
              <b-card-text class="mb-2">
                Upload audio and video meditations
              </b-card-text>

              <router-link
                to="/doom_yoga/meditation_library"
                class="card-link doomYogaLink"
              >
                Go To Library
                <span class=" mx-1 my-auto"> <font-awesome-icon icon="fa-solid fa-arrow-right"  class="align-middle"  /> </span>
              </router-link>
            </b-card>
            <b-card
              title="Upload Music"
              tag="article"
              class="card-transparent-background doom-yoga-border-div mb-2"
            >
              <b-card-text class="mb-2">
                Upload audio from Spotify or as MP3
              </b-card-text>

              <router-link
                to="/doom_yoga/music_library"
                class="card-link doomYogaLink"
              >
                Go To Library
                <span class=" mx-1 my-auto"> <font-awesome-icon icon="fa-solid fa-arrow-right" class="align-middle"  /> </span>
              </router-link>
            </b-card>
            <b-card
              title="Manage Memberships"
              tag="article"
              class="card-transparent-background doom-yoga-border-div mb-2"
            >
              <b-card-text class="mb-2">
                Create and manage memberships and packs
              </b-card-text>

              <router-link
                to="/doom_yoga/memberships_packs"
                class="card-link doomYogaLink"
              >
                Go To Packs
                <span class=" mx-1 my-auto"> <font-awesome-icon icon="fa-solid fa-arrow-right" class="align-middle"  /> </span>
              </router-link>
            </b-card>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "DoomYogaMyStudio",
  components: {},
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/doom_yoga/MyStudio.vue